import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { registerTheme } from 'echarts/core'
import { gammaEChartsTheme } from './theme/gamma-echarts-theme'
import App from './App.tsx'
import { queryClient } from './lib/queryClient'
import './styles/global.css'

// Register the Gamma ECharts theme globally so axis/grid styling is applied
registerTheme('gamma', gammaEChartsTheme)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
